import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { Draggable } from 'react-beautiful-dnd';
import _ from 'lodash';

import '../../index.css';

/**
 * Component for represent the column on drag and drop lib
 *
 * @param {*} props
 * @returns
 */
const DashboardDndColumn = (props) => {
  const { parentFilter, dndState, isEditMode, onRemoveClick } = props;
  /**
   * Render the columns for drag and drop lib
   */
  const renderColumns = () => {
    return _.map(dndState.columnOrder, (columnId, index) => {
      const column = dndState.columns[columnId];
      const elements = _.compact(
        _.map(column.elementsIds, (elementId) => dndState.elements[elementId])
      );

      return (
        <Droppable key={index} droppableId={column.columnId}>
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {renderColumnsElements(elements)}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      );
    });
  };

  /**
   * Render component elements inside on the respective columns
   * @param {Object} elements
   */
  const renderColumnsElements = (elements) => {
    return _.map(elements, (element, index) => {
      const draggableId = element.draggableId;
      const componentData = {
        parentFilter,
        draggableId,
        onRemoveClick,
        isEditMode,
      };

      return (
        <Draggable
          key={draggableId}
          draggableId={draggableId}
          index={index}
          isDragDisabled={!isEditMode}
        >
          {(provided) => (
            <div className="dnd-column-element">
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                {element.component(componentData)}
              </div>
            </div>
          )}
        </Draggable>
      );
    });
  };

  return <div>{renderColumns()}</div>;
};

export default DashboardDndColumn;
